module.exports = __webpack_public_path__ + "static/img/product_2.4c9e63f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product_2.jpg
// module id = JDuV
// module chunks = 1